import { useEffect } from "react";
import { useInternational } from "../../../store/international";
import { getMessageInError } from "../../../hooks/fetch";
import { message } from "antd";
import { useDispatch } from "react-redux";
import {
    internationalList,
    internationalListClear,
    internationalListErrorClear,
    InternationalListParams,
} from "../../../store/international/list";
import { Action } from "redux-saga";

export const useInternationalList = () => {
    const dispatch = useDispatch();
    const { list } = useInternational();

    const getInternationals = (params: InternationalListParams) => {
        dispatch(internationalList(params) as Action)
    }

    useEffect(() => () => {
        dispatch(internationalListClear() as Action)
        dispatch(internationalListErrorClear() as Action)
    }, [])

    useEffect(() => {
        if (list.error) {
            message
                .error(getMessageInError(list.error))
                .then(() => dispatch(internationalListErrorClear() as Action));
        }
    }, [list.error])


    return { getInternationals, response: list.response, error: list.error, loading: list.loading, };
}
